import type React from "react";
import { Grid, Box } from "@mui/material";
import EmptyWidget from "../admin-widgets/EmptyWidgets";
import BookingStatsWidget from "./BookingStats";
import MyAssignedBookings from "./MyAssignedBookings";

const SalesDashboard: React.FC = () => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <BookingStatsWidget />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 8 }}>
          <MyAssignedBookings />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <EmptyWidget title="" description="" icon="" />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <EmptyWidget title="" description="" icon="" />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <EmptyWidget title="" description="" icon="" />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <EmptyWidget title="" description="" icon="" />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SalesDashboard;
